var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "auth-layout" }, [
    _c("div", { staticClass: "main va-row" }, [
      _c(
        "div",
        {
          staticClass: "flex lg6 xs12 fill-height",
          class: {
            "auth-content": _vm.isLargeScreen,
            "auth-content-app": !_vm.isLargeScreen,
          },
          style: _vm.isLargeScreen
            ? ""
            : `height:100%;background-image:url(${_vm.rightBgH5});`,
        },
        [_c("div", { staticClass: "flex-center" }, [_c("router-view")], 1)]
      ),
      _c("div", {
        staticClass:
          "auth-layout__auth-wallpaper flex md6 auth-layout__auth-container",
        style: `height:100%;background-image:url(${_vm.rightBgPc});`,
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }